import React from 'react'
import {connect} from 'react-redux'
import classNames from 'classnames'

import {setAccommodationFilter} from '../../actions'
import './accommodationFilter.css'

// implicit dependencies:
// - flexboxgrid.css

export let FilterLink = ({filter, currentFilter, children, setFilter}) => {
  const linkClass = classNames('col-xs', {active: filter === currentFilter})
  return (
    <a
      href="#filter"
      className={linkClass}
      onClick={e => {
        e.preventDefault()
        setFilter()
      }}
    >
      {children}
    </a>
  )
}

const mapStateToProps = function(state) {
  return {
    currentFilter: state.accommodation.accommodationOptionsFilter,
  }
}

const mapDispatchToProps = function(dispatch, ownProps) {
  return {
    setFilter: function() {
      dispatch(setAccommodationFilter(ownProps.filter))
    },
  }
}

FilterLink = connect(mapStateToProps, mapDispatchToProps)(FilterLink)

const AccommodationFilterContainer = () => {
  return (
    <div className="accommodation-filter-container flexboxgrid h-margin-top-big h-margin-bottom-big">
      <div className="row">
        <FilterLink filter="SHOW_ALL">
          <div className="box">All</div>
        </FilterLink>
        <FilterLink filter="SHOW_BOOKINGDOTCOM">
          <div className="box">Booking.com</div>
        </FilterLink>
      </div>
    </div>
  )
}

export default AccommodationFilterContainer



// WEBPACK FOOTER //
// ./src/components/Accommodation/AccommodationFilter.js